import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Mantine and its styles, the query cache and the notifications belong to the panel: they are loaded, and
// provided, by the panel's own chunk (pages/dashboard/DashboardRoutes), not by the landing page.
import "./index.css";
import App from "./App";
import { store } from "./store/store";
import reportWebVitals from "./reportWebVitals";

// Preview mode (`REACT_APP_MOCK_API=1 npm start`): the API is answered by MSW from
// src/mocks, under a fake session. The import sits directly in a condition the
// bundler can evaluate (and not in an async function, which Babel turns into a
// state machine), so a production build contains neither the mock server nor the fixtures.
const mockApi: Promise<unknown> =
  process.env.NODE_ENV !== "production" && process.env.REACT_APP_MOCK_API === "1"
    ? import("./mocks/browser")
        .then(({ worker }) =>
          worker.start({
            onUnhandledRequest: "bypass",
            serviceWorker: { url: `${process.env.PUBLIC_URL}/mockServiceWorker.js` },
          })
        )
        .then(() => store.setToken("mock"))
    : Promise.resolve();

mockApi
  .then(() => {
    store.restoreSession();

    ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );

    reportWebVitals();
  })
  .catch((error) => console.error(error));
